import { render, staticRenderFns } from "./AddUserModalBulk.vue?vue&type=template&id=206253d2"
import script from "./AddUserModalBulk.vue?vue&type=script&lang=js"
export * from "./AddUserModalBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports